// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/big-logo-common-grey.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RevivalWrapper_bg__Al1Pa {
  width: 100vw;
  height: 100vh;
  background: #f5f5fe url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center bottom no-repeat;
  background-size: cover;
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
}
.RevivalWrapper_bg__Al1Pa div {
  width: 100%;
  max-width: 500px;
  margin: auto;
  text-align: center;
}
.RevivalWrapper_bg__Al1Pa h1 {
  font-size: 28px;
  font-weight: 400;
  color: #00007a;
  line-height: 48px;
  margin-bottom: 20px !important;
}
.RevivalWrapper_bg__Al1Pa h1 svg {
  width: auto;
  height: 28px;
  margin-bottom: -3px;
  margin-left: 10px;
}
.RevivalWrapper_bg__Al1Pa p {
  font-size: 16px;
  font-weight: 300;
  color: #00007a;
  line-height: 28px;
}`, "",{"version":3,"sources":["webpack://./src/components/Revival/RevivalWrapper/RevivalWrapper.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,YAAA;EACA,aAAA;EACA,mFAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AAIJ;AAFI;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAIR;AADI;EACI,eAAA;EACA,gBAAA;EACA,cCfG;EDgBH,iBAAA;EACA,8BAAA;AAGR;AADQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAGZ;AACI;EACI,eAAA;EACA,gBAAA;EACA,cC9BG;ED+BH,iBAAA;AACR","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.bg{\n    width: 100vw;\n    height: 100vh;\n    background: #f5f5fe url(../../../assets/big-logo-common-grey.svg) center bottom no-repeat;\n    background-size: cover;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    display: flex;\n\n    div{\n        width: 100%;\n        max-width: 500px;\n        margin: auto;\n        text-align: center;\n    }\n\n    h1{\n        font-size: 28px;\n        font-weight: 400;\n        color: colors.$primary8;\n        line-height: 48px;\n        margin-bottom: 20px!important;\n\n        svg{\n            width: auto;\n            height: 28px;\n            margin-bottom: -3px;\n            margin-left: 10px;\n        }\n    }\n\n    p{\n        font-size: 16px;\n        font-weight: 300;\n        color: colors.$primary8;\n        line-height: 28px;\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"bg": `RevivalWrapper_bg__Al1Pa`
};
export default ___CSS_LOADER_EXPORT___;
